export const NAV_FAVORITES_STORAGE_KEY = "inssa-studio.navFavorites.v1";

export function getNavItemFavoriteId(item) {
  return String(item?.key || item?.to || item?.label || "").trim();
}

export function toggleFavoriteNavItem(favoriteIds, itemId) {
  const normalizedId = String(itemId || "").trim();
  if (!normalizedId) return favoriteIds;

  const next = new Set(favoriteIds);
  if (next.has(normalizedId)) {
    next.delete(normalizedId);
  } else {
    next.add(normalizedId);
  }

  return Array.from(next);
}

export function buildFavoriteNavItems(sections, favoriteIds) {
  const favoriteSet = new Set(favoriteIds);

  return sections.flatMap((section) =>
    (section.items || []).filter((item) =>
      favoriteSet.has(getNavItemFavoriteId(item)),
    ),
  );
}

export function readFavoriteNavItemIds(storage) {
  if (!storage) return [];

  try {
    const parsed = JSON.parse(storage.getItem(NAV_FAVORITES_STORAGE_KEY) || "[]");
    return Array.isArray(parsed)
      ? parsed.map((value) => String(value || "").trim()).filter(Boolean)
      : [];
  } catch (_error) {
    return [];
  }
}

export function writeFavoriteNavItemIds(storage, favoriteIds) {
  if (!storage) return;

  try {
    storage.setItem(
      NAV_FAVORITES_STORAGE_KEY,
      JSON.stringify(
        Array.from(new Set(favoriteIds))
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    );
  } catch (_error) {
    // localStorage can be unavailable in private windows; favorites are optional.
  }
}
